<template>
  <div>
    <el-dialog
      title="SUBIR EVIDENCIAS"
      :visible.sync="dialogVisible"
      width="30%"
      @close="onEvidenceClose"
      append-to-body
    >
      <span>Subir Evidencias</span>

      <el-upload
        ref="uploadFile"
        class="upload-demo"
        :drag="true"
        action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
        :limit="1"
        :on-exceed="handleExceed"
        list-type="picture-card"
        :auto-upload="false"
        :multiple="true"
        :on-success="handleUploadOnSuccess"
        :on-change="handleChange"
        :on-remove="handleRemove"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          Solo archivos jpg/png con un tamaño menor de 26MG
        </div>
      </el-upload>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onEvidenceClose">Cancel</el-button>
        <el-button type="primary" v-if="filesUpload > 0" @click="submitUpload"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "EvidenceDialog",
  props: {
    isItVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    RequestTaskId: {
      type: String,
      default: "",
      required: true
    },
    RTID: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data() {
    return {
      filesUpload: 0,
      fileList: []
    };
  },
  computed: {
    dialogVisible() {
      return this.isItVisible;
    }
  },
  methods: {
    onEvidenceClose() {
      this.$refs.uploadFile.clearFiles();
      this.$emit("DialogCloses", false);
    },
    handleExceed(files) {
      this.$message.warning(
        `El límite es 1, haz seleccionado ${
          files.length
        } archivos esta vez, añade hasta ${files.length + 0}`
      );
    },
    handleUploadOnSuccess(response) {
      if (this.RequestTaskId.startsWith("SI-")) {
        this.fileList = response[0];
        var url = "/api/InternalServiceRequest/addEvidences";
        this.$http
          .get(url, {
            params: {
              evidences: this.fileList.Url,
              internalRequestId: this.RTID,
              createBy: this.currentUser.EmployeeId,
              tipo: 0
            },
            timeout: 3 * 60 * 100
          })
          .then((resp) => {
            if (resp.data) {
              this.$message({
                type: "success",
                message: "evidencia agregada exitosamente!"
              });
              this.$refs.uploadFile.clearFiles();
              this.filesUpload = 0;
            } else {
              this.$message.error("Error al agregar evidencia");
            }
          })
          .catch((error) => {
            this.$message.error("Error al agregar evidencia", error);
          })
          .finally(() => {
            this.dialogVisible = false;
            this.getItems();
          });
        this.__helperRequestChangeStatus(2, this.RTID);
      } else if (
        this.RequestTaskId.startsWith("T-") ||
        this.RequestTaskId.startsWith("Task-")
      ) {
        this.fileList = response[0];
        this.$http
          .post(
            `/api/cmi/task/AddEvidenceTaskGantt?ID=Task-${this.RTID}&Evidence=${this.fileList.Url}`
          )
          .then(() => {
            let message = "Evidencia de la Tarea fue agregado exitosamente";
            this.$message.success(message);
            this.$emit("updateReport");
            this.$emit("DialogCloses", false);
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err.message
            });
          })
          .finally(() => {
            this.GetGanttObjectives();
          });
        this.dialogVisible = false;
      }
    },
    __helperRequestChangeStatus(status, option) {
      this.$http
        .get("/api/InternalServiceRequest/SetStatusInRequestByTecnical", {
          params: {
            internalRequestId: option,
            status: status,
            userId: this.currentUser.EmployeeId
          },
          timeout: 3 * 60 * 100
        })
        .then((resp) => {
          if (resp.data) {
            this.$message({
              type: "success",
              message: "Estado de solicitud actualizado exitosamente!"
            });

            this.$emit("updateReport");
            this.$emit("DialogCloses", false);
          } else {
            this.$message.error("Error al establecer Estado de la solcitud");
          }
        })
        .catch((error) => {
          this.$message.error(
            "Error al establecer Estado de la solcitud",
            error
          );
        })
        .finally(() => {
          this.getItems();
        });
    },
    handleChange() {
      this.filesUpload = 1;
    },
    handleRemove() {
      this.filesUpload = 0;
    },
    submitUpload() {
      this.$refs.uploadFile.submit();
    }
  },
  watch: {
    isItVisible(newVal) {
      this.dialogVisible = newVal;
    }
  }
};
</script>

<style lang="scss" scoped></style>
